module.exports = __webpack_public_path__ + "Spaces.176e88b5b70b4405d0ea588d3384742d.hashedasset.svg";